import React from 'react'

import MainContainer from '../../components/MainContainer'
import MainHeader from '../../components/MainHeader'
import NotificationSoundsManager from '../../components/NotificationSoundsManager'

const NotificationSounds = () => {
  return (
    <MainContainer>
      <MainHeader
        title="Sons de Notificação"
        description="Gerencie a biblioteca global de áudios. A escolha do som de cada usuário agora fica no modal do usuário."
      />
      <NotificationSoundsManager />
    </MainContainer>
  )
}

export default NotificationSounds